import { useTranslation } from "react-i18next";
import { buildDataTableLabels } from "@/components/table";
import { Pagination } from "@/components/ui";
import { NOTIFICATIONS_PAGE_SIZE } from "./constants";

interface NotificationListPaginationProps {
  page: number;
  total: number;
  isLoading?: boolean;
  onPageChange: (page: number) => void;
}

export function NotificationListPagination({
  page,
  total,
  isLoading = false,
  onPageChange,
}: NotificationListPaginationProps) {
  const { t: tCommon } = useTranslation("common");
  const tableLabels = buildDataTableLabels(tCommon);
  const { t } = useTranslation("adminNotifications");

  if (total <= 0) {
    return null;
  }

  const totalPages = Math.max(1, Math.ceil(total / NOTIFICATIONS_PAGE_SIZE));
  if (totalPages <= 1) {
    return null;
  }

  return (
    <Pagination
      labels={tableLabels}
      page={page}
      totalPages={totalPages}
      total={total}
      isLoading={isLoading}
      showPageNumbers
      onPageChange={onPageChange}
      summary={t("pagination", { page, totalPages, total })}
      placement="bottom"
    />
  );
}
